import { merge } from '@vizit/theme';
import { composeRenderProps } from 'react-aria-components';

/**
 * Compose the tailwind render props. This is a utility function that composes
 * the class name prop with the tailwind class name.
 *
 * @param classNameProp - The class name prop.
 * @param tw - The tailwind class name.
 * @example
 * <div className={composeTailwindRenderProps(classNameProp, 'text-primary')}>
 *   Text
 * </div>
 */
export function composeTailwindRenderProps<T>(
  classNameProp: string | ((v: T) => string) | undefined,
  tw: string,
): string | ((v: T) => string) {
  return composeRenderProps(classNameProp, (className) => merge(tw, className));
}
